import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT, VIEW } from "const"
import {
    StoreType,
    setCcLibraryItemMenu,
    setCcLibraryItemParents,
    setCcLibraryItemConfirmDelete,
    setCcLibraryHeadingMenu,
    setCcLibraryHeadingConfirmDelete,
    addModal,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

import HeadingEdit from "../headingEdit"


interface MenuProps {
    editAccess: boolean
    addAccess: boolean
    baseRoute: string
}

const Menu = ({
    editAccess,
    addAccess,
    baseRoute,
}: MenuProps) => {
    const itemId = useSelector((state: StoreType) => state.ccLibraryItem.menuTargetId)
    const itemTargetElement = useSelector((state: StoreType) => state.ccLibraryItem.menuTargetElement)
    const headingId = useSelector((state: StoreType) => state.ccLibraryHeading.menuTargetId)
    const headingTargetElement = useSelector((state: StoreType) => state.ccLibraryHeading.menuTargetElement)

    const headingList = useSelector((state: StoreType) => state.ccLibraryHeading.headingList)
    const itemList = useSelector((state: StoreType) => state.ccLibraryItem.itemList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [menuItems, setMenuItems] = useState<any[]>([])

    const hideMenu = () => {
        dispatch(setCcLibraryItemMenu(null, null))
        dispatch(setCcLibraryHeadingMenu(null, null))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    useEffect(() => {
        if (headingId) {
            setMenuItems(createHeadingMenu())
        }

        if (itemId) {
            setMenuItems(createItemMenu())
        }
    }, [headingId, itemId])


    const currentHeading = headingList[headingId]
    const currentItem = itemList[itemId]

    const editParagraph = () => {
        dispatch(addModal({
            key: "editParagraph",
            content: <HeadingEdit headingId={currentHeading.id} parentId={currentHeading.headingId} />,
        }))
    }
    const addParagraph = () => {
        dispatch(addModal({
            key: "addParagraph",
            content: <HeadingEdit headingId={0} parentId={currentHeading.id} />,
        }))
    }
    const addCompliantItem = () => {
        dispatch(setCcLibraryItemParents(null, currentHeading.id))
        dispatch(addModal({ url: `${baseRoute}/${EDIT}/0` }))
    }
    const deleteParagraph = () => {
        dispatch(setCcLibraryHeadingConfirmDelete(currentHeading))
    }
    const viewCompliantItem = () => {
        dispatch(addModal({ url: `${baseRoute}/${VIEW}/${currentItem.id}` }))
    }
    const editCompliantItem = () => {
        dispatch(setCcLibraryItemParents(currentItem.itemId, currentItem.headingId))
        dispatch(addModal({ url: `${baseRoute}/${EDIT}/${currentItem.id}` }))
    }
    const addNestedItem = () => {
        dispatch(setCcLibraryItemParents(currentItem.id, null))
        dispatch(addModal({ url: `${baseRoute}/${EDIT}/0` }))
    }
    const deleteCompliantItem = () => {
        dispatch(setCcLibraryItemConfirmDelete(currentItem))
    }


    const createHeadingMenu = () => {
        const menu: any[] = []
        if (editAccess) {
            menu.push(
                <PopupMenuItem key="editParagraph" onClick={editParagraph}>
                    {lang.edit}
                </PopupMenuItem>,
                <PopupMenuItem key="addParagraph" onClick={addParagraph}>
                    {lang.addParagraph}
                </PopupMenuItem>,
            )
        }
        if (addAccess) {
            menu.push(
                <PopupMenuItem key="addCompliantItem" onClick={addCompliantItem}>
                    {lang.addCompliantItem}
                </PopupMenuItem>,
            )
        }
        if (editAccess) {
            menu.push(
                <PopupMenuItem key="deleteParagraph" onClick={deleteParagraph}>
                    {lang.delete}
                </PopupMenuItem>,
            )
        }
        return menu
    }

    const createItemMenu = () => {
        const menu: any[] = []
        menu.push(
            <PopupMenuItem key="viewCompliantItem" onClick={viewCompliantItem}>
                {lang.view}
            </PopupMenuItem>,
        )
        if (editAccess) {
            menu.push(
                <PopupMenuItem key="editCompliantItem" onClick={editCompliantItem}>
                    {lang.edit}
                </PopupMenuItem>,
            )
        }
        if (addAccess) {
            menu.push(
                <PopupMenuItem key="addNestedItem" onClick={addNestedItem}>
                    {lang.addCompliantItem}
                </PopupMenuItem>,
            )
        }
        if (editAccess) {
            menu.push(
                <PopupMenuItem key="deleteCompliantItem" onClick={deleteCompliantItem}>
                    {lang.delete}
                </PopupMenuItem>,
            )
        }
        return menu
    }

    const target = itemTargetElement || headingTargetElement || null
    if (!menuItems.length) return null
    return (
        <PopupMenu
            show={itemId !== null || headingId !== null}
            target={target}
            placement="right"
        >
            {menuItems}
        </PopupMenu>
    )
}

export default Menu
